import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Login } from "./auth";
import { Signup } from "./Signup";
import Layout from "./Layout";
import { Home } from "./home";
import { Quizzes } from "./quizzes";
import { Settings } from "./Settings";
import Journal from "./journal";
import Entries from "./journalEntries";
import ChatbaseGreeting from "./ChatbaseGreeting";

import { MockInterview } from "./MockInterview";
import MoodTrends from "./MoodTrends";
import MiniLoFiPlayer from "./MiniLofiPlayer";
import { XPProvider } from "./XPContext";
import XPDisplay from "./XPDisplay";
import ResumeUploader from "./ResumeUploader";
import PersonalityQuiz from "./PersonalityQuiz";

export default function App() {
  return (
    <XPProvider>
      <BrowserRouter>
        <XPDisplay />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<Layout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/quizzes" element={<Quizzes />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/entries" element={<Entries />} />
          <Route path="/mood-trends" element={<MoodTrends />} />
          <Route path="/mock-interview" element={<MockInterview />} />
          <Route path="/lofi" element={<MiniLoFiPlayer />} />
          <Route path="/resume-checker" element={<ResumeUploader />} />
          <Route path="/personality-quiz" element={<PersonalityQuiz />} />
          </Route>
        </Routes>
        <ChatbaseGreeting /> {/* keep this */}
      </BrowserRouter>
    </XPProvider>
  );
}
